export default __webpack_public_path__ + "static/media/fourPieces3.142c05aa.jpg";